import React from "react";
import { decodeEntities } from "@wordpress/html-entities";
import "./index.css";
import RequestDemo from "../../Button/RequestDemo";
import btnClasses from "../../commons/Button.module.scss";

const Service = ({
  widthBig = "",
  heightBig = "",
  image,
  text = "",
  children,
  widthSmall = "",
  heightSmall = "",
  imageSmall = "",
}) => {
  return (
    <section className="service">
      <div className="container">
        <div className="service__body">
          <h2
            className="service__title"
            dangerouslySetInnerHTML={{
              __html: decodeEntities(
                text ? text : "Do you want to try our service?"
              ),
            }}
          />
          {children ? children : <RequestDemo className={btnClasses.button} />}
          <div className="service__image">
            <picture>
              <source
                srcSet={imageSmall}
                media="(max-width: 600px)"
                width={widthSmall}
                height={heightSmall}
              />
              <img
                height={heightBig}
                width={widthBig}
                src={image}
                alt="Service"
              />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service;
